import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, usePublicAmendmentSearchDispatch } from './public-amendment-search-context';
import { usePublicPortalBasePath } from '../../../../context/public-client-context';
import { IAmendmentPagedResponse } from '../../../../../../model/sge/amendment/response/amendment-paged-response';

const INTEGER_FIELDS: Record<string, string> = {
    'input-year': 'year',
    'select-status': 'status',
    'select-type': 'type',
};

export const usePublicAmendmentSearchController = () => {
    const navigate = useNavigate();
    const dispatch = usePublicAmendmentSearchDispatch();
    const basePath = usePublicPortalBasePath();

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name in INTEGER_FIELDS) {
            const parsed = parseInt(value, 10);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { [INTEGER_FIELDS[name]]: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-search') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { search: value || undefined } });
        } else if (name === 'input-min-value') {
            const parsed = parseFloat(value);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { minValue: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-max-value') {
            const parsed = parseFloat(value);
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { maxValue: isNaN(parsed) ? undefined : parsed } });
        } else if (name === 'input-start-date') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { startDate: value || undefined } });
        } else if (name === 'input-end-date') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { endDate: value || undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0, pageSize: 20, year: undefined, status: undefined, type: undefined, search: undefined,
                minValue: undefined, maxValue: undefined, startDate: undefined, endDate: undefined,
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToDetail(row: IAmendmentPagedResponse) {
        navigate(`${basePath}/emendas/${row.id}`, {
            state: { parlamentarName: row.parlamentarName, politicalPartyAbbreviation: row.politicalPartyAbbreviation }
        });
    }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToDetail };
};
